import { render, staticRenderFns } from "./BulkSubmissions.vue?vue&type=template&id=d36df33e&scoped=true"
import script from "./BulkSubmissions.vue?vue&type=script&lang=js"
export * from "./BulkSubmissions.vue?vue&type=script&lang=js"
import style0 from "./BulkSubmissions.vue?vue&type=style&index=0&id=d36df33e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36df33e",
  null
  
)

export default component.exports